// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zv0k","right":"styles_right__1tON3"};